<template>
  <div class="goods-order big">
    <el-table :data="goodsData"
              border
              style="width: 100%; margin-top: 20px">
      <el-table-column v-for="item in tableHeader"
                       :key="item.prop"
                       :prop="item.prop"
                       :label="item.label"
                       :width="item.width"
                       :align="item.align">
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     size="medium"
                     @click="editorBtn(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分账编辑 -->
    <el-dialog :title="dialogTitle"
               :visible.sync="goodsDialog"
               width="600px"
               style="text-align:left;"
               :close-on-click-modal="true"
               append-to-body
               class="big">
      <div class="recipe-dialog">
        <el-form :model="goodsForm"
                 :rules="rules"
                 ref="goodsFormRef"
                 label-width="180px"
                 class="demo-goodsForm">

          <el-form-item label="是否开启分账"
                        prop="is_open">
            <el-switch v-model="goodsForm.is_open"
                       :active-value="1"
                       :inactive-value="0"></el-switch>
          </el-form-item>

          <el-form-item label="快递费用"
                        prop="freight_price">
            <el-select style="width: 330px;"
                       v-model="goodsForm.freight_price"
                       placeholder="请选择">
              <el-option v-for="item in configList"
                         :key="item.key"
                         :label="item.name"
                         :value="item.key"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="商品成本金额"
                        prop="drug_cost_price">
            <el-select style="width: 330px;"
                       v-model="goodsForm.drug_cost_price"
                       placeholder="请选择">
              <el-option v-for="item in configList"
                         :key="item.key"
                         :label="item.name"
                         :value="item.key"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="商品加价金额"
                        prop="drug_difference_price">
            <el-select style="width: 330px;"
                       v-model="goodsForm.drug_difference_price"
                       placeholder="请选择">
              <el-option v-for="item in configList"
                         :key="item.key"
                         :label="item.name"
                         :value="item.key"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="save('goodsFormRef')"
                   size="small"
                   :disabled=" module_id_array[0] ? !module_id_array.includes('731') : false"
                   type="primary"
                   plain>保 存</el-button>
        <el-button @click="close"
                   size="small"
                   :disabled=" module_id_array[0] ? !module_id_array.includes('731') : false"
                   plain>关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import system from '../../../api/system';
export default {
  props: {
    configList: {
      type: Array,
      require: true,
      default: function () {
        return [];
      }
    }
  },
  data() {
    return {
      goodsDialog: false,
      dialogTitle: '',
      goodsForm: {
        is_open: '',
        freight_price: '',
        drug_cost_price: '',
        drug_difference_price: ''
      },
      rules: {
        is_open: [{ required: true, message: '请选择', trigger: 'change' }],
        freight_price: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        drug_cost_price: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        drug_difference_price: [
          { required: true, message: '请选择', trigger: 'change' }
        ]
      },
      tableHeader: [
        {
          label: '商户名称',
          prop: 'shop_name',
          width: 'auto',
          algin: 'center'
        }
      ],
      goodsData: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      if (this.module_id_array[0] && !this.module_id_array.includes('730')) {
        return;
      }
      system.getChinaumsShop().then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.goodsData = data.list;
        }
      });
    },
    editorBtn(row) {
      for (let key in row) {
        if (!row[key] && row[key] !== 0) {
          row[key] = '';
        }
      }
      this.dialogTitle = row.shop_name;
      this.goodsDialog = true;
      this.$nextTick(() => {
        this.$refs['goodsFormRef'].resetFields();
        this.goodsForm = Object.assign(this.goodsForm, row);
      });
    },
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          system.setChinaumsShop(this.goodsForm).then((res) => {
            let { code } = res;
            if (code == 0) {
              this.$message.success('保存成功');
              this.goodsDialog = false;
              this.getList();
            }
          });
        } else {
          return false;
        }
      });
    },
    close() {
      this.goodsDialog = false;
    }
  }
};
</script>

<style>
</style>